import {useIntl} from 'react-intl'

/**
 * Custom hook that sets up and returns the configuration for the search store field.
 * This field is used to input a city, town, or postal code for store searching.
 *
 * @returns {Object} An object containing the configuration for the search field.
 * @returns {Object} return.search - The configuration for the search input field.
 * @returns {string} return.search.name - The name of the search field, prefixed with 'store_search'.
 * @returns {Object} return.search.label - The label for the search field, localized using `formatMessage`.
 * @returns {string} return.search.defaultValue - The default value for the search field, which is an empty string.
 * @returns {string} return.search.type - The type of the search field, which is 'text'.
 * @returns {Object} return.search.control - The control object from the form, used for managing field state.
 */

export default function useSearchStoreField({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        search: {
            name: `${prefix}_field`,
            label: formatMessage({
                defaultMessage: 'City, Town or Post Code',
                id: 'stores_page.search.label'
            }),
            defaultValue: '',
            type: 'text',
            control
        }
    }
    return fields
}
